export default "__VITE_ASSET__CqcxB_Xq__"